import { ALL_DOCUMENT_OPTIONS, EUpdateAreaEnum, TableTypes } from '@/constant';
import { OutputType } from '@/hooks';

import { DefaultOptionType } from 'antd/es/select';

import { TFunction } from 'i18next';
import { isNonEmptyArray } from 'ramda-adjunct';

import { renderData } from '../config';

export const getColumnsHistoryMobile = (
	content: OutputType<TableTypes.UPDATE_HISTORY>['list'],
	historyUpdateOptionJson: {
		[key: string]: DefaultOptionType & { optionJson?: any };
	},
	t: TFunction<['updateHistory', 'national'], undefined>,
	isForeignRole: boolean
) => {
	if (!isNonEmptyArray(content)) return [];
	return content?.map((item) => {
		const documentOptionObj = ALL_DOCUMENT_OPTIONS.find(
			(option) => option.value === item.fieldName
		);
		const documentOption = isForeignRole
			? documentOptionObj?.labelEn
			: documentOptionObj?.label;

		const fileName =
			item?.fieldArea === EUpdateAreaEnum.DOCUMENT_INFO
				? documentOption
				: historyUpdateOptionJson[item?.fieldName]?.label ?? item?.fieldName;

		return {
			id: {
				value: item?.id,
				className: 'w-max mr-2 text-spanishGray',
				label: 'NO. ',
			},
			registDt: {
				value: item.registDt,
				className: 'float-right mt-[0.556vw] text-spanishGray',
			},
			fileName: {
				value: t(fileName as any),
				className: '!block font-semibold text-[15px]',
				label: '',
			},
			prevData: {
				value: renderData(
					typeof item?.prevData === 'object'
						? item?.prevData?.name
						: item?.prevData,
					item,
					historyUpdateOptionJson,
					t
				),
				className: '!block',
				label: '전: ',
			},
			afterData: {
				value: renderData(
					typeof item?.afterData === 'object'
						? item?.afterData?.name
						: item?.afterData,
					item,
					historyUpdateOptionJson,
					t
				),
				className: '!block',
				label: '후: ',
			},
		};
	});
};
